<template>
  <v-dialog
      v-model="dialog"
      max-width="500"
      persistent
  >
    <v-card>
      <v-card-title class="headline warning--text">
        <v-icon
            left
            color="warning"
        >
          mdi-alert
        </v-icon>
        {{ title }}
      </v-card-title>

      <v-card-text>
        <div
            v-if="hasMultipleMessages"
            class="pt-3"
        >
          <div
              v-for="(msg, index) in messages"
              :key="index"
              class="mb-2"
          >
            {{ msg }}
          </div>
        </div>
        <div
            v-else
            class="pt-3"
        >
          {{ messages }}
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="grey darken-1"
            text
            @click="cancel"
        >
          {{ cancelText }}
        </v-btn>
        <v-btn
            color="warning"
            depressed
            @click="confirm"
        >
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmationAlert",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "Atenção",
    },
    messages: {
      type: [String, Array],
      default: () => [],
    },
    confirmText: {
      type: String,
      default: "Confirmar",
    },
    cancelText: {
      type: String,
      default: "Cancelar",
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    hasMultipleMessages() {
      return Array.isArray(this.messages);
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    confirm() {
      this.$emit("confirm");
    },
  },
};
</script>
